import React from "react";
import { string, func, bool, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Loadericon from "../../atoms/load-more-button-loader";

import "./button.m.css";

const Button = ({
  content,
  onClick,
  buttonType,
  isArrow,
  isOpen,
  className,
  isLoaderActive,
  buttonId,
  selectedItem,
  publisherAttributes,
  buttonStyle,
  textStyle,
  ...props
}) => {
  const arrowView = () => (isOpen ? <i styleName="up" className="up" /> : <i styleName="down" className="down" />);

  return (
    <button
      styleName={`${buttonType} ${publisherAttributes.lang}-button`}
      className={className}
      onClick={onClick}
      {...props}
      style={buttonStyle}
    >
      {isLoaderActive && buttonId === selectedItem ? (
        <Loadericon />
      ) : (
        <span className="content" style={textStyle}>
          {content}
        </span>
      )}
      {isArrow ? arrowView() : null}
    </button>
  );
};

Button.defaultProps = {
  buttonType: "type1",
  isOpen: false,
  isArrow: false,
  className: "button",
};

Button.propTypes = {
  content: string.isRequired,
  onClick: func,
  buttonType: string,
  isOpen: bool,
  isArrow: bool,
  className: string,
  isLoaderActive: bool,
  buttonId: string,
  selectedItem: string,
  buttonStyle: object,
  publisherAttributes: object,
  textStyle: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(Button);
